import { render, staticRenderFns } from "./waitread.vue?vue&type=template&id=c70d0d7a&scoped=true"
import script from "./waitread.vue?vue&type=script&lang=js"
export * from "./waitread.vue?vue&type=script&lang=js"
import style0 from "./waitread.vue?vue&type=style&index=0&id=c70d0d7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70d0d7a",
  null
  
)

export default component.exports